import { createFileRoute } from "@tanstack/react-router"
import { WhatsappOpeningMessageCreate } from "modules/campaigns/components/Sections/channels/whatsappOpeningMessages/WhatsappOpeningMessageCreate"

export const Route = createFileRoute("/_base/_auth/settings/channels/whatsapp/openings/create")({
  component: WhatsappOpeningMessageCreate,
})
